import React, { useEffect, useState } from "react";
import CommonDivWidget from "components/CommonDivWidget/CommonDivWidget";
import { message, Spin, DatePicker, Row, Col, Pagination } from "antd";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import { TitleSearch } from "components/SearchWidget/TitleSearch";
import TableWidget from "./TableWidget/TableWidget";
import { showAddProductDialog } from "./AddProductDialog/showAddProductDialog";
import {
  apiCreateShopProduct,
  apiDeleteShopProduct,
  apiGetShopProductList,
  apiUpdateShopProduct,
} from "services/shopProductService";
const { RangePicker } = DatePicker;

function ShopProductListPage() {
  const [isBusy, setIsBusy] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    setIsBusy(true);
    apiGetShopProductList(currentPage, pageSize, startDate, endDate)
      .then((data) => {
        setIsBusy(false);
        setDataList(data.dataList);
        setSearchList(data.dataList);
        setTotalCount(data.total_count);
      })
      .catch((err) => {
        setIsBusy(false);
        setDataList([]);
        setSearchList([]);
        message.error("Sorry! " + err);
      });
  }, [pageSize, currentPage, startDate, endDate]);

  const onShowSizeChange = (current, size) => {
    setPageSize(size);
    setCurrentPage(current);
  };
  const onChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const stripHtml = (html) => {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html || "";
    return tmp.textContent || tmp.innerText || "";
  };

  const handleSearch = (searchText) => {
    const tmpList = dataList.filter((info) =>
      stripHtml(info.name).toLowerCase().includes(searchText.toLowerCase())
    );
    setSearchList([...tmpList]);
  };
  const handleChange = (event) => {
    if (event.target.value === "") {
      setSearchList(dataList);
    } else {
      handleSearch(event.target.value);
    }
  };

  const handleDateFilter = (start, end) => {
    setCurrentPage(1);
    setStartDate(start);
    setEndDate(end);
  };

  const onNewProduct = async () => {
    var res = await showAddProductDialog({
      title: "New Product",
      isEditing: false,
    });
    if (res === null) return;
    setIsBusy(true);
    apiCreateShopProduct(res)
      .then((data) => {
        setIsBusy(false);
        if (data === null) {
          message.error("There's something wrong while adding New Product");
          return;
        }
        var tmpData = [...dataList, data];
        setDataList(tmpData);
        setSearchList(tmpData);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error("Error! " + err);
      });
  };

  const onClickDelete = (pInfo) => {
    setIsBusy(true);
    apiDeleteShopProduct(pInfo.id)
      .then(() => {
        setIsBusy(false);
        let updateData = [...dataList];
        var storeIndex = updateData.findIndex((x) => x.id == pInfo.id);
        updateData.splice(storeIndex, 1);
        setDataList([...updateData]);
        setSearchList([...updateData]);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  const onClickEdit = async (pInfo) => {
    var res = await showAddProductDialog({
      title: "Edit Product",
      record: pInfo,
      isEditing: true,
    });
    if (res === null) return;
    setIsBusy(true);
    apiUpdateShopProduct(res)
      .then((data) => {
        setIsBusy(false);
        if (data === null) {
          message.error("There's something wrong while updating a Product");
          return;
        }
        let updateData = [...dataList];
        var storeIndex = updateData.findIndex((x) => x.id == data.id);
        updateData.splice(storeIndex, 1, data);
        setDataList(updateData);
        setSearchList(updateData);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  return (
    <CommonDivWidget>
      <Spin spinning={isBusy}>
        <h1>Product List</h1>
        <Row>
          <Col>
            <div style={{ fontFamily: "mediumFont", padding: 20 }}>
              Date Filter Period : &nbsp;&nbsp;
              <RangePicker
                size={"default"}
                onChange={(e, date) => {
                  if (date == null) {
                    handleDateFilter("", "");
                  } else {
                    handleDateFilter(date[0], date[1]);
                  }
                }}
              />
            </div>
          </Col>
          <Col flex={"auto"}>
            <div style={{ fontFamily: "mediumFont", padding: 20 }}>
              <TitleSearch
                onSearch={handleSearch}
                onChange={handleChange}
                onPressEnter={handleSearch}
              />
            </div>
          </Col>
          <Col>
            <div style={{ fontFamily: "mediumFont", padding: 20 }}>
              <CommonButton onClick={onNewProduct}>New</CommonButton>
            </div>
          </Col>
        </Row>
        <Row justify={"center"} style={{ paddingTop: 16 }}>
          <Col>
            <Pagination
              showSizeChanger
              onShowSizeChange={onShowSizeChange}
              onChange={onChange}
              defaultCurrent={1}
              current={currentPage}
              total={totalCount}
              pageSize={pageSize}
            />
          </Col>
        </Row>

        <div style={{ paddingTop: 32 }}>
          <TableWidget
            dataList={searchList}
            onUpdateAction={onClickEdit}
            onDeleteAction={onClickDelete}
          />
        </div>
      </Spin>
    </CommonDivWidget>
  );
}

export default ShopProductListPage;
